import React from 'react'
import { useAppSelector } from 'reduxTyped'

import { FieldGroupId } from 'common/fields/entities/enums'
import { Field } from 'common/fields/entities/field'
import { getUserFields } from 'common/fields/linking/accountAvailableFields'
import FieldPicker, { FieldPickerProps } from 'common/fields/linking/components/FieldPicker'
import { FieldSelectEvent } from 'common/fields/linking/components/interfaces/fieldEvents'
import { getNumberedId } from 'common/tags/components/ConditionTagPicker/helpers'

type AllowedValue = string | number | null | undefined

export interface UserFieldSelectEvent {
  target: { value: number; field: Field; name?: string }
}

type UserFieldPickerProps = {
  onChange: (event: UserFieldSelectEvent) => void
  selector?: (state: Pick<RootState, 'availableFields'>) => Field[]
  label?: string
  ariaLabel: string
  value: AllowedValue
  helpText?: string
} & Omit<FieldPickerProps, 'fields' | 'onSelect' | 'value'>

const UserFieldPicker: React.ForwardRefRenderFunction<HTMLInputElement, UserFieldPickerProps> = (
  { name, onChange, ariaLabel, selector = getUserFields, value, helpText, ...pickerProps },
  ref,
) => {
  const fields = useAppSelector(selector)

  const handleChange = (event: FieldSelectEvent) => {
    const value = getNumberedId(FieldGroupId.USER, event.target?.value)
    onChange({ target: { ...event.target, value } })
  }

  return (
    <FieldPicker
      {...pickerProps}
      ref={ref}
      fields={fields}
      name={name}
      onSelect={handleChange}
      value={value ? `cuf_${value}` : ''}
      ariaLabel={ariaLabel}
      helpText={helpText}
    />
  )
}

export default React.forwardRef(UserFieldPicker)
